import React from 'react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../components/ui/PageHeader';
import { Card, CardContent } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { MapPin, Phone, Mail, Download, MessageCircle, Clock } from 'lucide-react';
import { CFA_INFO, PHONE_DISPLAY, PHONE_HREF, WHATSAPP_HREF } from '../data/constants';
import { useSeo } from '../hooks/useSeo';
export function Contact() {
  useSeo({
    title: 'Contact — CFA Zillenium Alternance à Joigny',
    description: 'Contactez Zillenium Alternance : 25 rue Gabriel Cortel, 89300 Joigny. Téléphone 09 83 49 01 81, WhatsApp et e-mail. Nous répondons rapidement à vos questions sur l’alternance.',
    path: '/contact'
  });
  return <div className="flex flex-col w-full" data-id="element-1336" data-mp="fa7qoz5hwh6p">
      <PageHeader title="Contactez-nous" subtitle="Une question sur nos formations, l'alternance ou notre CFA ? Notre équipe est à votre disposition." data-id="element-1337" data-mp="f8woh3rp7hhp" />

      <div className="py-16 md:py-24 bg-muted relative overflow-hidden" data-id="element-1338" data-mp="15fyjl6oq4lhi">
        <div className="absolute top-0 left-0 w-[500px] h-[500px] bg-primary rounded-full blur-[100px] opacity-10 pointer-events-none" data-id="element-1339" data-mp="19h0oo45bnrre" />
        <div className="container max-w-6xl mx-auto relative z-10" data-id="element-1340" data-mp="1e8s53lurkh3t">
          <div className="grid lg:grid-cols-3 gap-12 lg:gap-16" data-id="element-1341" data-mp="1j6k8bc0uzpnb">
            {/* Coordonnées */}
            <div className="lg:col-span-1 space-y-10" data-id="element-1342" data-mp="mgufmcc1hhwp">
              <div data-id="element-1343" data-mp="mi5k6edb6tov">
                <h2 className="text-3xl font-extrabold font-heading text-primary-dark mb-8" data-id="element-1344" data-mp="minlhpetvy3n">
                  Nos coordonnées
                </h2>
                <div className="space-y-8" data-id="element-1345" data-mp="vgzkoftrg47p">
                  <div className="flex items-start gap-5 group" data-id="element-1346" data-mp="vjc4kyj2wone">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1347" data-mp="10h581jszz4jz">
                      <MapPin className="w-6 h-6 text-brand-orange" data-id="element-1348" data-mp="2bv918nrrgonz" />
                    </div>
                    <div data-id="element-1349" data-mp="1m73k5ltz5083">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1350" data-mp="1m6bzv75tuox4">
                        Adresse
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1351" data-mp="1had6141qcepb">
                        {CFA_INFO.address}
                      </p>
                    </div>
                  </div>

                  <div className="flex items-start gap-5 group" data-id="element-1352" data-mp="1r780nbuvtuyb">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1353" data-mp="13hxaspf2lkyy">
                      <Phone className="w-6 h-6 text-brand-orange" data-id="element-1354" data-mp="1d6p00psqxr66" />
                    </div>
                    <div data-id="element-1355" data-mp="18fyu9bgermay">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1356" data-mp="18fp0dcs8suzz">
                        Téléphone
                      </h3>
                      <a href={PHONE_HREF} className="text-primary font-medium hover:text-brand-orange transition-colors" data-id="element-1357" data-mp="kojnn6hlmitw">
                        {PHONE_DISPLAY}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-5 group" data-id="element-1358" data-mp="2w7g4ku4rph65">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1359" data-mp="2hhs0jl57c4eq">
                      <Mail className="w-6 h-6 text-brand-orange" data-id="element-1360" data-mp="3a5e5awq61f36" />
                    </div>
                    <div data-id="element-1361" data-mp="3f3z54v1i9wr3">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1362" data-mp="3f4h788aun56x">
                        E-mail
                      </h3>
                      <a href={`mailto:${CFA_INFO.email}`} className="text-primary font-medium hover:text-brand-orange transition-colors underline underline-offset-4 break-all" data-id="element-1363" data-mp="3146et0tw5ijn">
                        {CFA_INFO.email}
                      </a>
                    </div>
                  </div>

                  <div className="flex items-start gap-5 group" data-id="element-1364" data-mp="29z2id74y9mmp">
                    <div className="w-14 h-14 bg-white shadow-sm rounded-2xl flex items-center justify-center shrink-0 group-hover:scale-110 transition-transform" data-id="element-1365" data-mp="257ki6lar3q2s">
                      <Clock className="w-6 h-6 text-brand-orange" data-id="element-1366" data-mp="208hbkwf4hbsp" />
                    </div>
                    <div data-id="element-1367" data-mp="1vaxzo35wdb3x">
                      <h3 className="font-bold text-lg text-primary-dark mb-1" data-id="element-1368" data-mp="2swvb5glv0g6d">
                        Délai de réponse
                      </h3>
                      <p className="text-muted-foreground leading-relaxed" data-id="element-1369" data-mp="2nytq4q4vi6s9">
                        Sous 48 heures ouvrées, immédiatement par téléphone
                        pendant nos horaires d'ouverture.
                      </p>
                    </div>
                  </div>
                </div>
              </div>

              <div className="pt-10 border-t border-slate-200" data-id="element-1370" data-mp="17kvbhy53spal">
                <h2 className="text-2xl font-extrabold font-heading text-primary-dark mb-6" data-id="element-1371" data-mp="13gvw5ivk7wit">
                  Accès rapides
                </h2>
                <div className="flex flex-col gap-4" data-id="element-1372" data-mp="3f37kroa2p1mg">
                  <Button className="w-full justify-start py-6 text-base bg-primary hover:bg-primary-dark text-white shadow-md" asChild data-id="element-1373" data-mp="3j7xcr21m1w23">
                    <Link to="/offres" data-id="element-1374" data-mp="3sxqoq45o0d6v">Voir les offres d'alternance</Link>
                  </Button>
                  <Button variant="outline" className="w-full justify-start py-6 text-base border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold" asChild data-id="element-1375" data-mp="1pcjmk2o3irt">
                    <Link to="/faq" data-id="element-1376" data-mp="ap9ej3fnhdvb">Consulter la FAQ</Link>
                  </Button>
                  <Button variant="secondary" className="w-full justify-start py-6 text-base bg-lavande text-primary-dark hover:bg-lavande/80 font-semibold" asChild data-id="element-1377" data-mp="fo2s0vuxt4vh">
                    <Link to="/catalogue" data-id="element-1378" data-mp="3krxqobbrd74s">
                      <Download className="w-5 h-5 mr-3" data-id="element-1379" data-mp="3kspntql07cx6" />
                      Consulter le catalogue
                    </Link>
                  </Button>
                </div>
              </div>
            </div>

            {/* Canaux de contact directs */}
            <div className="lg:col-span-2" data-id="element-1380" data-mp="3otrng8iu1qzo">
              <Card className="border-none shadow-2xl bg-white overflow-hidden" data-id="element-1381" data-mp="3osq31dfxfs5a">
                <div className="h-2 w-full bg-brand-orange" data-id="element-1382" data-mp="7kcs6acc6y97" />
                <CardContent className="p-8 md:p-12" data-id="element-1383" data-mp="2ncog62ym7l9">
                  <h2 className="text-3xl font-extrabold font-heading text-primary-dark mb-4" data-id="element-1384" data-mp="2kqg4488vo1z">
                    Écrivez-nous ou appelez-nous
                  </h2>
                  <p className="text-muted-foreground text-lg leading-relaxed mb-10" data-id="element-1385" data-mp="cdp7tuz1fupt">
                    Nous répondons directement, sans intermédiaire. Choisissez
                    le canal qui vous convient le mieux.
                  </p>

                  <div className="grid sm:grid-cols-2 gap-5 mb-10" data-id="element-1386" data-mp="lbhlyvt0wwbm">
                    <a href={PHONE_HREF} className="flex flex-col gap-3 bg-lavande rounded-2xl p-6 hover:bg-lavande/70 transition-colors" data-id="element-1387" data-mp="14zngwdmzq3r7">
                      <span className="w-12 h-12 rounded-xl bg-white flex items-center justify-center" data-id="element-1388" data-mp="v0oirozupqig">
                        <Phone className="w-5 h-5 text-primary" data-id="element-1389" data-mp="zy6l2wjd57hh" />
                      </span>
                      <span data-id="element-1390" data-mp="m7bh9ynq1gkr">
                        <span className="block font-extrabold font-heading text-lg text-primary-dark" data-id="element-1391" data-mp="qzcov79y2j4g">
                          Nous appeler
                        </span>
                        <span className="block text-primary-dark/70 font-semibold" data-id="element-1392" data-mp="cc9s52tg4ei6">
                          {PHONE_DISPLAY}
                        </span>
                      </span>
                    </a>

                    <a href={WHATSAPP_HREF} target="_blank" rel="noopener noreferrer" className="flex flex-col gap-3 bg-primary-dark text-white rounded-2xl p-6 hover:bg-primary transition-colors" data-id="element-1393" data-mp="3bv43vp3klaz">
                      <span className="w-12 h-12 rounded-xl bg-white/10 flex items-center justify-center" data-id="element-1394" data-mp="ipxiv9jnwpt0">
                        <MessageCircle className="w-5 h-5 text-brand-orange" data-id="element-1395" data-mp="8tm1w694nbs8" />
                      </span>
                      <span data-id="element-1396" data-mp="4rqs0dd4rq2u">
                        <span className="block font-extrabold font-heading text-lg" data-id="element-1397" data-mp="4t25x60aie7o">
                          WhatsApp
                        </span>
                        <span className="block text-lavande font-semibold" data-id="element-1398" data-mp="3w4tqs611w8zk">
                          Réponse rapide
                        </span>
                      </span>
                    </a>

                    <a href={`mailto:${CFA_INFO.email}`} className="flex flex-col gap-3 bg-slate-50 rounded-2xl p-6 hover:bg-slate-100 transition-colors sm:col-span-2" data-id="element-1399" data-mp="3m6nsrzid7mzz">
                      <span className="w-12 h-12 rounded-xl bg-white flex items-center justify-center shadow-sm" data-id="element-1400" data-mp="1sqjg13qhphet">
                        <Mail className="w-5 h-5 text-brand-orange" data-id="element-1401" data-mp="1wqbo7fbz1ljn" />
                      </span>
                      <span data-id="element-1402" data-mp="21rhmrtsbc313">
                        <span className="block font-extrabold font-heading text-lg text-primary-dark" data-id="element-1403" data-mp="21r9b257xf3rh">
                          Nous écrire par e-mail
                        </span>
                        <span className="block text-primary-dark/70 font-semibold break-all" data-id="element-1404" data-mp="193dd6x6mf5t4">
                          {CFA_INFO.email}
                        </span>
                      </span>
                    </a>
                  </div>

                  <div className="bg-lavande/50 rounded-2xl p-6" data-id="element-1405" data-mp="1nqop506psrtr">
                    <h3 className="font-extrabold font-heading text-lg text-primary-dark mb-3" data-id="element-1406" data-mp="1nrztb142o1le">
                      Vous souhaitez candidater ou recruter ?
                    </h3>
                    <p className="text-muted-foreground leading-relaxed mb-5" data-id="element-1407" data-mp="v92t4t5kjzte">
                      Des formulaires dédiés vous permettent de transmettre
                      votre dossier complet, CV inclus, en une seule fois.
                    </p>
                    <div className="flex flex-col sm:flex-row gap-3" data-id="element-1408" data-mp="yw1imo075vpi">
                      <Button className="bg-brand-orange hover:bg-[#E67E22] text-white font-bold py-6 px-6" asChild data-id="element-1409" data-mp="ytp1ue66dre1">
                        <Link to="/candidater" data-id="element-1410" data-mp="68xj2yjvi9l4">Je candidate</Link>
                      </Button>
                      <Button variant="outline" className="border-primary/20 text-primary-dark hover:bg-primary/5 font-semibold py-6 px-6" asChild data-id="element-1411" data-mp="b6gyw2w7yuf6">
                        <Link to="/entreprises" data-id="element-1412" data-mp="3jm8yeayicjwg">Je recrute un alternant</Link>
                      </Button>
                    </div>
                  </div>
                </CardContent>
              </Card>
            </div>
          </div>
        </div>
      </div>
    </div>;
}